(() => {
  const commercePath = /\/(?:products|collections)(?:\/|$)/;

  const isCommerceLink = (link) => {
    const href = link.getAttribute('href') || link.dataset.mtjPreviewHref;
    if (!href) return false;

    try {
      return commercePath.test(new URL(href, window.location.origin).pathname);
    } catch {
      return false;
    }
  };

  const disableLink = (link) => {
    if (!isCommerceLink(link) || link.classList.contains('mtj-preview-disabled-link')) return;

    link.dataset.mtjPreviewHref = link.getAttribute('href');
    link.removeAttribute('href');
    link.classList.add('mtj-preview-disabled-link');
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('tabindex', '-1');
  };

  const disableLinksWithin = (root) => {
    if (root instanceof Element && root.matches('a[href]')) disableLink(root);
    root.querySelectorAll?.('a[href]').forEach(disableLink);
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const link = target?.closest('a');
      if (!link) return;

      if (link.classList.contains('mtj-preview-disabled-link') || isCommerceLink(link)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  const initialize = () => {
    disableLinksWithin(document);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) disableLinksWithin(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
